class CollectionSubscription extends HTMLElement {
    constructor(){
        super();
        this.rcDrawer;
        // this.rcWidget;
        this.init();
    }

    async init(){
        this.rcDrawer = document.querySelector('.product-grid-container.quick-add-drawer-content');
        // this.rcWidget = document.querySelector('.product-grid-container .quick-add-drawer-content .rc-custom-widget');

        // console.log(this.rcDrawer);
        this.midWidget(this.rcDrawer);
    }

    async midWidget(rcWidget){
        let variantID = Number(rcWidget.getAttribute('data-variant-id')),
            productID = rcWidget.getAttribute('data-product-id'),
            product = await recharge.cdn.getCDNProduct(productID),
            widget = await recharge.cdn.getCDNWidgetSettings(this.productID);
        
        console.log(productID);
        console.log(product.id);


        let widgetTemplate = rcWidget;
        widgetTemplate.classList.add('radio-group');

        this.renderWidget(widgetTemplate, variantID, widget, product);
    }

    async renderWidget(widgetTemplate, variantID, widget, prod){

        // // Assign several variables by destructuring from the instance object
        let sellingVariant = prod.variants.find(obj => obj.id === variantID),
            sellingPlan = '',
            priceEl,
            price = sellingVariant.prices.unit_price,
            compareAtPrice = sellingVariant.prices.compare_at_price,
            subscribePrice = sellingVariant.prices.discounted_price;


        //subscription is selected first
        if(widget.select_subscription_first){
            sellingPlan = sellingVariant.selling_plan_allocations[0].selling_plan_id;
            price = subscribePrice;
        }

        // Determine the correct price element based on whether there is a compare-at price
        // if (compareAtPrice) {
        //     priceEl = document.querySelector('.price__sale .price-item.price-item--sale');
        // } else {
        //     priceEl = document.querySelector('.price__regular .price-item.price-item--regular')
        // }

        // input element for the selling plan and add it to product form
        let sellingPlanInput = document.createElement('input');
            sellingPlanInput.classList.add('selling-plan-input')
            sellingPlanInput.name = 'selling_plan';
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.value = sellingPlan;
            widgetTemplate.querySelector('.product-form form').appendChild(sellingPlanInput);

        // should change how this
        widgetTemplate.querySelector('.one-time .radio-template .radio').checked = false;
        widgetTemplate.querySelector('.subscription .radio-template .radio').checked = false;


        this.renderSubscriptionRadio(widgetTemplate, widget, prod, sellingVariant);
        this.renderOneTimeRadio(widgetTemplate, widget, sellingVariant, prod);

        this.renderVariation(widgetTemplate, widget, prod, sellingVariant);

        widgetTemplate.querySelector('.product-form .product-variant-id').addEventListener('change',(ev) => this.updateRadioWidget(prod, widgetTemplate));
        widgetTemplate.querySelector('.quick-add-close').addEventListener('click',(ev) => this.closeQuickAddDrawer());


        // Update the product price with the correct price
        this.updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice);
    }

    closeQuickAddDrawer() {
        document.getElementById('QuickAddDrawer').classList.remove('active');
        document.getElementById('QuickAddOverlay').classList.remove('active');
    }

    renderVariation(widgetTemplate, widget, prod, sellingVariant){
        let va = widgetTemplate.querySelector('.variant'),
            session = va.getAttribute('data-session'),
            inputs;

        if(va.getAttribute('data-variant-exists') == 'false'){
            inputs = va.querySelectorAll('.variant_input');
            inputs[0].classList.add('selected');
            inputs.forEach(imp => {
                imp.addEventListener('click', (ev) => this.updateVariantInputs(widgetTemplate, imp, prod, session));
            })
        }
   
    }

    // Function to adjust the footer when bottom nav appears or disappears
    adjustFooterPosition(widgetTemplate) {
        const footer = widgetTemplate.querySelector('.buy-button-wrapper');
        // Detect if the bottom navigation bar is visible (based on window height)
        const isNavBarVisible = window.innerHeight < document.documentElement.clientHeight;

        if (isNavBarVisible) {
            // Bottom nav bar is visible, slide the footer up
            footer.style.transform = 'translateY(-100px)';  // Adjust this value to control how much it slides up
        } else {
            // Bottom nav bar is not visible, keep the footer at the bottom
            footer.style.transform = 'translateY(0)';
        }
    }

    updateVariantInputs(widgetTemplate, imp, prod, session) {
        widgetTemplate.querySelector('.variant_input.selected').classList.remove('selected');
        imp.classList.add('selected');
        // console.log(variant)
        // console.log(imp.getAttribute('data-variant'));

        // console.log(session);
        // console.log(widgetTemplate.querySelector(`#${session}`));
        
        widgetTemplate.querySelectorAll(`#${session}`).forEach((productForm) => {
            // console.log(productForm.className);
            const input = productForm.querySelector('input[name="id"]');
            // console.log(input.className);
            // console.log(imp.getAttribute('data-variant'));
            input.value = imp.getAttribute('data-variant') ?? '';
            // console.log(input.value);
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
    }

    getSellingVariant(prod, variantID) {
        let sellingVariant;

        // get selling plan of current variant and set it as the value of the selling sellingVariant variable
        prod.variants.forEach(function (variant) {
            if (variant.id === variantID) {
                sellingVariant = variant
            }
        })

        return sellingVariant
    }

    renderSubscriptionRadio(widgetTemplate, widget, prod, sellingVariant){
        let subscribeText = widget.subscribe_without_discount_message,
            price = sellingVariant.prices.unit_price,
            discountedPrice = sellingVariant.prices.discounted_price,
            compareAtPrice = sellingVariant.prices.compare_at_price,
            discount = (price > discountedPrice),
            subscribePrice = price,
            _this = this;

        // if a discount is applied, change the text to the subscribe with discount message and set the price to the discounted price
        if (discount) {
            subscribePrice = discountedPrice;
            subscribeText = widget.subscribe_message;
            widgetTemplate.querySelector('.subscription .option-discount').innerText = prod.selling_plan_groups[0].selling_plans[0].price_adjustments_value + '%'
        }

        widgetTemplate.querySelector('.subscription .option-text').innerHTML = subscribeText;
        widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice

        //extra stuff
        // if the widget is set to select the subscription radio by default, add the active class and check the radio button
        // if (widget.widget_template_type === 'radio_group' || widget.widget_template_type === 'button_group') {
        //     widgetTemplate.appendChild(document.querySelector('.subscription .widget__selling-plans'));
        //     document.querySelector('.widget .subscription .widget__selling-plans-dropdown__label').classList.remove('visually-hidden')
        // }

        // //setting subscription radio as the default choice
        if(widget.select_subscription_first){
            widgetTemplate.querySelector('.subscription.radio-wrapper').classList.add('radio-active');
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = true;

            widgetTemplate.setAttribute('data-selected', 'subscription');
            widgetTemplate.querySelector('.price-item.price-item--regular').innerText = '$' + subscribePrice;
        }

        sellingVariant.selling_plan_allocations.forEach(item => {
            let option = document.createElement('div'),
                planGroup = prod.selling_plan_groups.find(obj => obj.selling_plan_group_id == item.selling_plan_group_id),
                plan = planGroup.selling_plans.find(obj => obj.selling_plan_id == item.selling_plan_id);
                discount = plan.price_adjustments_value + '%';

            option.className = "delivery"
            option.value = plan.selling_plan_id;
            option.innerText = plan.selling_plan_name;
            // option.innerText = plan.order_interval_frequency + " " + plan.order_interval_unit_type + "s";
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', item.discount_price);

            // option.createElement('span')

            widgetTemplate.querySelector('.shipping-dates').appendChild(option);
        })

        // loop through the variant selling plan allocations selling plans and add them to the dropdown
        sellingVariant.selling_plan_allocations.forEach(function (item) {
            let option = document.createElement('option'),
                planGroup = prod.selling_plan_groups.find(obj => obj.selling_plan_group_id == item.selling_plan_group_id),
                plan = planGroup.selling_plans.find(obj => obj.selling_plan_id == item.selling_plan_id),
                discount = plan.price_adjustments_value + '%';

            // attach necessary data to the option
            option.value = plan.selling_plan_id;
            option.innerText = plan.selling_plan_name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', item.discounted_price);

            // append the option to the dropdown
            widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').appendChild(option);
        })

        const deliveryBtn = widgetTemplate.querySelectorAll('.delivery');
        deliveryBtn[0].classList.add('selected');
        deliveryBtn.forEach(btn => {
            btn.addEventListener('click', function(){
                widgetTemplate.querySelector('.shipping-dates .delivery.selected').classList.remove('selected');
                btn.classList.add('selected');
                widgetTemplate.querySelector('.product-form form .selling-plan-input').value = btn.value;
            })
        })

        widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').addEventListener('change', function () {
            widgetTemplate.querySelector('.product-form form .selling-plan-input').value = this.value;
        })
        
        widgetTemplate.querySelector('.subscription .radio-template .radio').addEventListener('change',(ev) => this.handleSubscriptionChange(ev, widgetTemplate, prod));
    }

    renderOneTimeRadio(widgetTemplate, widget, sellingVariant, prod){
        let price = sellingVariant.prices.unit_price,
            oneTimeText = widget.onetime_message;

        widgetTemplate.querySelector('.one-time .option-text').innerText = oneTimeText;
        widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + price;

        // // if the widget is set to not select the subscription radio by default, add the active class and check the radio button
        // // if (!widget.select_subscription_first) {
        if (!widget.select_subscription_first) {
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.add('hidden');
            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.one-time.radio-wrapper').classList.add('radio-active');
            widgetTemplate.setAttribute('data-selected', 'one-time');
        }

        widgetTemplate.querySelector('.one-time .radio-template .radio').addEventListener('change', (ev) => this.handleOneTimeChange(ev, widgetTemplate, widget, prod));
        // widgetTemplate.querySelector('.one-time .radio-template .radio').addEventListener('change', this.handleOneTimeChange.bind(this));
    }


    handleSubscriptionChange(ev, widgetTemplate, prod){
        if (ev.target.checked){
            let variantID = Number(widgetTemplate.querySelector('.product-form .product-variant-id').value),
                sellingVariant = this.getSellingVariant(prod, variantID),
                price = sellingVariant.prices.unit_price,
                compareAtPrice = sellingVariant.prices.compare_at_price,
                subscribePrice = sellingVariant.prices.discounted_price,
                sellingPlanInput = widgetTemplate.querySelector('.product-form form .selling-plan-input');


            sellingPlanInput.value = widgetTemplate.querySelector('.shipping-dates .delivery.selected').value

            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = false;
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.remove('hidden')
            widgetTemplate.querySelector('.radio-wrapper.radio-active').classList.remove('radio-active');
            widgetTemplate.querySelector('.subscription.radio-wrapper').classList.add('radio-active');

            
            widgetTemplate.setAttribute('data-selected', 'subscription');
            this.updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice);
        }
    }

    handleOneTimeChange(ev, widgetTemplate, widget, prod){
        if(ev.target.checked){
            let variantID = Number(widgetTemplate.querySelector('.product-form .product-variant-id').value),
                sellingVariant = this.getSellingVariant(prod, variantID),
                price = sellingVariant.prices.unit_price,
                compareAtPrice = sellingVariant.prices.compare_at_price,
                sellingPlanInput = widgetTemplate.querySelector('.product-form form .selling-plan-input');

            sellingPlanInput.value = '';
            widgetTemplate.querySelector('.subscription .radio-template .radio').checked = false;
            widgetTemplate.querySelector('.subscription .radio-template .shipping-dates').classList.add('hidden');
            widgetTemplate.querySelector('.one-time .radio-template .radio').checked = true;
            widgetTemplate.querySelector('.radio-wrapper.radio-active').classList.remove('radio-active');
            widgetTemplate.querySelector('.one-time.radio-wrapper').classList.add('radio-active');

            // // price update
            widgetTemplate.setAttribute('data-selected', 'one-time');
            this.updatePrice(widgetTemplate, price, null, compareAtPrice);
        }
    }

    updateRadioWidget(prod, widgetTemplate){
        let variantID = Number(widgetTemplate.querySelector('.product-form .product-variant-id').value),
            sellingVariant = this.getSellingVariant(prod, variantID),
            priceContainer = widgetTemplate.querySelector('.price'),
             price = sellingVariant.prices.unit_price,
            subscribePrice = sellingVariant.prices.discounted_price,
            compareAtPrice = sellingVariant.prices.compare_at_price,
            subscriptionRadio = widgetTemplate.querySelector('.subscription .radio-wrapper .radio'),
            oneTimeRadio = widgetTemplate.querySelector('.one-time .radio-wrapper .radio'),
            sellingPlanInput = widgetTemplate.querySelector('.product-form form .selling-plan-input');
            // sellingPlanSelect = widgetTemplate.querySelector('.widget__selling-plans-dropdown__select');

        // console.log(sellingVariant);

        priceContainer.classList.add('recharge-price-modifier');

        widgetTemplate.querySelector('.subscription .shipping-dates').innerHTML = ''
        widgetTemplate.querySelector('.subscription .widget__selling-plans-dropdown__select').innerHTML = ''


        sellingVariant.selling_plan_allocations.forEach(function (item, i){
            let option = document.createElement('div'),
                planGroup = prod.selling_plan_groups.find(obj => obj.selling_plan_group_id == item.selling_plan_group_id),
                plan = planGroup.selling_plans.find(obj => obj.selling_plan_id == item.selling_plan_id),
                discount = plan.price_adjustments_value + '%';

            if (i === 0) {
                // set the subscribePrice variable to the price of the first plan
                subscribePrice = item.discounted_price;
                widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice;
            }

            // // attach necessary data to the option
            option.className = "delivery"
            option.value = plan.selling_plan_id;
            option.innerText = plan.selling_plan_name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', item.discount_price);

            widgetTemplate.querySelector('.subscription .shipping-dates').appendChild(option);
        })

        // loop through the variant selling plan allocations selling plans and add them to the dropdown
        sellingVariant.selling_plan_allocations.forEach(function (item, i) {
            let option = document.createElement('option'),
                planGroup = prod.selling_plan_groups.find(obj => obj.selling_plan_group_id == item.selling_plan_group_id),
                plan = planGroup.selling_plans.find(obj => obj.selling_plan_id == item.selling_plan_id),
                discount = plan.price_adjustments_value + '%';

            if (i === 0) {
                    // set the subscribePrice variable to the price of the first plan
                subscribePrice = item.discounted_price;
                widgetTemplate.querySelector('.subscription .option-price').innerText = '$' + subscribePrice;
            }

            // attach necessary data to the option
            option.value = plan.selling_plan_id;
            option.innerText = plan.selling_plan_name;
            option.setAttribute('data-discount', discount);
            option.setAttribute('data-price', item.discounted_price);

            // append the option to the dropdown
            widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').appendChild(option);
        })

        widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + sellingVariant.prices.unit_price;

        const deliveryBtn = widgetTemplate.querySelectorAll('.delivery');
        deliveryBtn[0].classList.add('selected');
        deliveryBtn.forEach(btn => {
            btn.addEventListener('click', function(){
                widgetTemplate.querySelector('.shipping-dates .delivery.selected').classList.remove('selected');
                btn.classList.add('selected');
                widgetTemplate.querySelector('.product-form form .selling-plan-input').value = btn.value;
            })
        })

        widgetTemplate.querySelector('.widget__selling-plans-dropdown__select').addEventListener('change', function () {
            widgetTemplate.querySelector('.product-form form .selling-plan-input').value = this.value;
        })

        // widgetTemplate.querySelector('.one-time .option-price').innerText = '$' + sellingVariant.prices.unit_price;
        // widgetTemplate.setAttribute('data-selected', 'subscription');


        this.updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice);
    }

    // updates the price when the variant or selling plan is changed
    updatePrice(widgetTemplate, price, subscribePrice, compareAtPrice) {
        let selected = widgetTemplate.getAttribute('data-selected'),
            priceContainer = widgetTemplate,
            priceEl,
            newPrice;

        if (selected === 'one-time') {
            newPrice = price;
        } else if (selected === 'subscription') {
            newPrice = subscribePrice;
        }

        // console.log(newPrice);

        if (compareAtPrice != null ) {
            priceContainer.querySelector('.price').classList.add('price--on-sale')
            priceEl = priceContainer.querySelector('.price__sale .price-item.price-item--sale');
            priceContainer.querySelector('.price__sale .price-item.price-item--regular').innerText = '$' + compareAtPrice
        } else {
            priceContainer.querySelector('.price').classList.remove('price--on-sale');
            priceEl = priceContainer.querySelector('.price__regular .price-item.price-item--regular');
        }

        priceEl.innerText = '$' + newPrice;
    }
}

customElements.define('collection-subscription', CollectionSubscription);